export var LOCALE_STATUS = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    DEFAULT: 'DEFAULT',
    DELETED: 'DELETED',
};
